import { BreakpointObserver } from '@angular/cdk/layout';
import { inject, Injectable } from '@angular/core';

// decimales de la compañía usados por todo el formulario de generación de documentos
@Injectable({ providedIn: 'root' })
export class DocumentGenerateConfigService {
  moneyDecimals = 2; // company.numberOfDecimals (mostrado al usuario)
  stockDisplayDecimals = 3; // company.stockDecimalsDisplay
  calcDecimals = 2; // company.priceDecimalsWork (para cálculos)

  private breakpointObserver = inject(BreakpointObserver);

  setFromCompany(company: any): void {
    if (!company) return;
    this.moneyDecimals = company.numberOfDecimals ?? this.moneyDecimals;
    this.stockDisplayDecimals = company.stockDecimalsDisplay ?? this.stockDisplayDecimals;
    this.calcDecimals = company.priceDecimalsWork ?? this.calcDecimals;
  }

  // redondea un valor a los decimales de cálculo (priceDecimalsWork)
  roundCalc(value: number): number {
    const factor = Math.pow(10, this.calcDecimals);
    return Math.round((Number(value) || 0) * factor) / factor;
  }

  get isPhoneScreen(): boolean {
    return !this.breakpointObserver.isMatched('(min-width: 600px)');
  }

  get isCompactScreen(): boolean {
    return !this.breakpointObserver.isMatched('(min-width: 960px)');
  }

  get isWideScreen(): boolean {
    return this.breakpointObserver.isMatched('(min-width: 1280px)');
  }

  // dimensiones de diálogo por viewport; ningún ancho llega a 100vw para que el overlay
  // quede visible en los cuatro lados y el diálogo se lea siempre como modal
  dialogSize(tier: 'lg' | 'md' | 'sm'): {
    width: string;
    maxWidth: string;
    height?: string;
    maxHeight: string;
    autoFocus: boolean;
  } {
    const phone = this.isPhoneScreen;
    const compact = this.isCompactScreen;
    const wide = this.isWideScreen;

    // acotados: se ajustan al contenido, nunca fijan altura
    if (tier === 'sm') {
      return {
        width: phone ? '92vw' : compact ? '480px' : wide ? '480px' : '520px',
        maxWidth: '92vw',
        maxHeight: '88vh',
        autoFocus: false,
      };
    }

    // medios: se ajustan al contenido con tope, para no dejar espacio muerto
    if (tier === 'md') {
      return {
        width: phone ? '92vw' : compact ? '86vw' : wide ? '60vw' : '82vw',
        maxWidth: '92vw',
        maxHeight: '88vh',
        autoFocus: false,
      };
    }

    // grandes: listados largos, conviene altura estable
    return {
      width: phone ? '94vw' : compact ? '90vw' : wide ? '92vw' : '95vw',
      maxWidth: '95vw',
      height: phone ? '90vh' : compact ? '88vh' : '92vh',
      maxHeight: '92vh',
      autoFocus: false,
    };
  }
}
